import MapSourceBoundaryContext from 'context/map-source-boundary-context'

export default function useSourceBoundary() {
  return React.useContext(MapSourceBoundaryContext)
}
